export default "__VITE_ASSET__Bru1$vDB__"